mutation DispatchGetCurrentConfig($agentRegistrationId: ID!) {
  dispatchGetCurrentConfig(
    input: { agentRegistrationId: $agentRegistrationId }
  ) {
    workItem {
      id
      databaseId
      status
    }
    errors
  }
}
